// extracted by css-extract-rspack-plugin
export default {"cls1":"ExportFormatModal-cls1_-LU","cls2":"ExportFormatModal-cls2_ErF ExportFormatModal-cls1_-LU"};